import { render } from "./AlarmSettingsEditGroups.vue?vue&type=template&id=20ad985e"
import script from "./AlarmSettingsEditGroups.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsEditGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__